import React from 'react';

import {uuid} from '../../helpers/uuid';
import {CombinationTypes, FINAL_BET_DATA_MODEL} from '../../enums/tableNumbers';
import {observer} from "mobx-react-lite";
import {doChipStore} from "../../store/doChipStore";
import {useRouletteDoBetValidation} from "../../hooks/useRouletteDoBetValidation";

const FinalBet = observer(({handleMouseMove, handleMouseLeave}) => {
  const {selectedChip} = doChipStore;
  const {handleDoBetInCombination} = useRouletteDoBetValidation();

  const handleDoChip = (e) => {
    const valueType = e.target.getAttribute("data");
    const model = CombinationTypes[valueType];
    if (model) {
      if (selectedChip) {
        handleDoBetInCombination(model, selectedChip, valueType);
      }
    }
  };
  return (
    <div className='r-bt-num-wrp' onMouseLeave={handleMouseLeave}>
      {
        FINAL_BET_DATA_MODEL.map(item => {
          return (
            <div className='r-num-count'
                 key={uuid()}
                 data={item.type}
                 onClick={handleDoChip}
                 onMouseMove={handleMouseMove}
                 onMouseLeave={handleMouseLeave}
            />
          );
        })
      }
    </div>
  );
});

export default FinalBet;
